import React, { useEffect, useState } from 'react';
import Authorize from '../../../components/AuthComponent/Authorize';
import SaveButton from '../../../components/Buttons/SaveButton';
import ButtonBar from '../../../components/Fields/ButtonBar';
import MultiSelectField from '../../../components/Fields/MultiSelectField';
import { FormConfig } from '../../../components/Fields/Types';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import Translate from '../../../components/Translate';
import { ApplicationFunctions } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ApplicationRoleItemTypesModel from '../../../models/ApplicationRoleItemTypesModel';
import DataService from "../../../services/data.service";
import { DataResult } from '../../../types/Result';

interface IProps {
    applicationRoleId
}

const ApplicationRole_tab_ItemTypes: React.FC<IProps> = ({ applicationRoleId }) => {
    const [formData, setFormData] = useState<ApplicationRoleItemTypesModel>();
    const [serverErrors, setServerErrors] = useState<DataResult<ApplicationRoleItemTypesModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();
    const itemTypes = useSelectListOptions('api/v1/selectlist/ItemTypes?activeOnly=true');

    useEffect(() => {
        getFormData();
    }, [applicationRoleId]);

    function getFormData() {
        DataService.get<ApplicationRoleItemTypesModel>(`api/v1/ApplicationRoles/${applicationRoleId}/ItemTypes`)
            .then(response => {
                console.log('UserDefinedFields:', response)
                setFormData(response);
            })
            .catch(e => { handleException(e); });
    }

    function submit() {
        if (formData) {
            DataService
                .put<DataResult<ApplicationRoleItemTypesModel>>(`api/v1/ApplicationRoles/${applicationRoleId}/ItemTypes`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                })
                .catch(e => handleException(e));
        }
    }

    function onFieldChanged(name: string, value: string): void {
        if (formData) {
            name.split('.').reduce((object, propertyName, index, elements) => {
                if (index === elements.length - 1) {
                    object[propertyName] = value;
                    setFormData(formData);
                }

                if (object && object[propertyName]) {
                    return object[propertyName];
                }
                return null;
            }, formData);
        }
    }

    const formConfig: FormConfig = {
        fields: [],
        handleSubmit: submit,
        handleFieldChanged: onFieldChanged,
        showErrors: 'always',
    };

    if (formData && formData.applicationFunctions) {
        formData.applicationFunctions.forEach((appFunction, index) => {
            formConfig.fields.push({
                name: `applicationFunctions.${index}.typeIds`,
                label: appFunction.applicationFunction,
                labelSize: 3
            });
        });
    }

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!formData || !formData.applicationFunctions)
        return null;

    var fields = formData.applicationFunctions.map((appFunction, index) => {
        return <MultiSelectField {...getFieldProps(`applicationFunctions.${index}.typeIds`)} options={itemTypes} key={`${index}`} />
    })

    //console.log(formConfig)
    //console.log(fields)

    return (
        <div>
            <h2><Translate>Don't forget to uncheck the application function above when detailing per item-type!</Translate></h2>
            {fields}
            <ButtonBar offset={2}>
                <Authorize applicationFunction={ApplicationFunctions.UpdateApplicationRole}>
                    <SaveButton  {...getSubmitButtonProps()} />
                </Authorize>
            </ButtonBar>
        </div>
    );
}
export default ApplicationRole_tab_ItemTypes;